import React, { useState } from 'react';
import { FileText, Download, Filter } from 'lucide-react';
import { Button } from '../ui/Button';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

export const AdminReports: React.FC = () => {
  const [dateRange, setDateRange] = useState<[Date, Date]>([
    new Date(new Date().getFullYear(), 0, 1), // 1er janvier de l'année en cours
    new Date()
  ]);
  const [selectedAgencies, setSelectedAgencies] = useState<string[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const handleGenerateReport = () => {
    // Logique de génération de rapport à implémenter
    console.log('Generating report with:', {
      dateRange,
      selectedAgencies,
      selectedUsers
    });
  };

  return (
    <section className="space-y-6">
      <div className="flex items-center gap-3">
        <FileText className="h-6 w-6 text-primary-500" />
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Rapports détaillés
        </h2>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Filter className="h-5 w-5 text-gray-400" />
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              Filtres du rapport
            </h3>
          </div>
          <Button
            onClick={handleGenerateReport}
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Générer le rapport
          </Button>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
              Période
            </label>
            <div className="mt-2 grid gap-4">
              <input
                type="date"
                value={dateRange[0].toISOString().split('T')[0]}
                onChange={(e) => setDateRange([new Date(e.target.value), dateRange[1]])}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
              />
              <input
                type="date"
                value={dateRange[1].toISOString().split('T')[0]}
                onChange={(e) => setDateRange([dateRange[0], new Date(e.target.value)])}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
              Agences
            </label>
            <select
              multiple
              value={selectedAgencies}
              onChange={(e) => setSelectedAgencies(Array.from(e.target.selectedOptions, option => option.value))}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
              size={5}
            >
              <option value="agency1">Agence 1</option>
              <option value="agency2">Agence 2</option>
              <option value="agency3">Agence 3</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
              Utilisateurs
            </label>
            <select
              multiple
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(Array.from(e.target.selectedOptions, option => option.value))}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
              size={5}
            >
              <option value="user1">Utilisateur 1</option>
              <option value="user2">Utilisateur 2</option>
              <option value="user3">Utilisateur 3</option>
            </select>
          </div>
        </div>

        <div className="mt-6 space-y-4">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-200">
            Rapports récents
          </h4>
          <div className="divide-y divide-gray-200 rounded-lg border border-gray-200 dark:divide-gray-700 dark:border-gray-700">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between p-4 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <div>
                  <p className="font-medium text-gray-900 dark:text-white">
                    Rapport {i + 1}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    Généré le {format(new Date(), 'PPP', { locale: fr })}
                  </p>
                </div>
                <Button variant="secondary" size="sm">
                  <Download className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};